import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '吃瓜视频', href: '#media' },
  { label: '独家专题', href: '#index' },
  { label: 'APP直达', href: '#app' },
  { label: '特色优势', href: '#features' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-950/90 backdrop-blur-xl border-b border-white/5">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px]">
          <a href="#hero" className="flex items-center gap-2 shrink-0">
            <div className="w-8 h-8 md:w-9 md:h-9 bg-accent-500 rounded-lg flex items-center justify-center">
              <i className="ri-flashlight-line text-white text-lg"></i>
            </div>
            <span className="text-white font-bold text-lg md:text-xl tracking-tight font-heading">爆料网</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/8 rounded-lg transition-colors whitespace-nowrap font-medium"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#contact"
              className="px-4 py-2 bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap"
            >
              我要投稿
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white/80 hover:text-white"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-xl border-t border-white/5">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-white/70 hover:text-white hover:bg-white/8 rounded-lg transition-colors text-sm font-medium"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMobileOpen(false)}
              className="mt-2 px-4 py-2.5 bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold rounded-full text-center transition-colors"
            >
              我要投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}